export class WorkflowStepLibraryQubitConcentrationsModel {

  id: number;
  concentration: number;
  concentration1: number;
  concentration2: number;
  ad: number;
  dilution: number;

  constructor(id: number, concentration: number, concentration1: number, concentration2: number, ad: number, dilution: number) {
    this.id = id;
    this.concentration = concentration;
    this.concentration1 = concentration1;
    this.concentration2 = concentration2;
    this.ad = ad;
    this.dilution = dilution;
  }

}
